'use strict';

/* global $ dataLayer FormData */

import Cookies from 'js-cookie';
import { ITGWebservice } from './../services/ITGWebservice';


export class AnalyticsUserIds {
    constructor () {
        // console.log('constructing AnalyticsUserIds');
        // console.log(Cookies.get('userId'));
        let user_id = Cookies.get('userId');
        if (user_id !== undefined) {
            // console.log('JS - no user id found in cookie');
            this.session_user_id = user_id;
            dataLayer.push({
                'userId': user_id
            });
        }
    }

    setUserId (user_id, form = false) {
        var d = new Date();
        d.setTime(d.getTime() + 1000 * 60 * 60 * 24 * 365 * 2);
        var expires = 'expires=' + d.toGMTString();
        document.cookie = 'userId=' + user_id + '; ' + expires + '; path=/';

        this.session_user_id = user_id;

        if (form) {
            dataLayer.push({
                'userId': user_id,
                'event': 'primo',
                'primoform': form
            });
        } else {
            dataLayer.push({
                'userId': user_id
            });
        }
    }

    getSetRemoteUserId (query, form = false) {
        ITGWebservice.sendRequest(ITGWebservice.api_url, ITGWebservice.endpoint_analytics_user_ids(query), {}, 'json').done((data) => {
            // console.log(data);
            if (data && data.error && data.error.httpcode) {
                // new ErrorMsg(data.error.httpcode);
                console.log('error send');
            } else {
                this.setUserId(data.google_analytics_id, form);
            }
        });
    };
};



// WEBPACK FOOTER //
// ./front/js/modules/analytics_user_ids.js